import React, { useEffect, useState } from "react";
import { Platform } from "react-native";
import configStore, { sagaMiddleware } from "./store";
import initSagas from "./initSagas";
import { Provider } from "react-redux";

// import * as serviceWorkerRegistration from "./src/serviceWorkerRegistration";
// import * as serviceWorker from "./serviceWorker";
import { Text } from "react-native";
import * as Font from "expo-font";
import RootSpinner from "./rootSpinner";


export const store = configStore();
initSagas(sagaMiddleware);

function Main() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      await Font.loadAsync({
        Roboto: require("./native-base/Fonts/Roboto-Regular.ttf"),
        Roboto_medium: require("./native-base/Fonts/Roboto-Medium.ttf"),
      });
      setLoading(false);
    })();
  }, []);

  return loading ? (
    <Text>{'loading'}</Text>
  ) : (
    <Provider store={store}>
      <RootSpinner />
    </Provider>
  );
}
export default Main;

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// TODO in LT-706
// serviceWorkerRegistration.register();

if (!(Platform.OS === "android" || Platform.OS === "ios")) {
}
